export default __webpack_public_path__ + "static/media/icon.heart.e29b6d4f.svg";